module.exports = __webpack_public_path__ + "static/img/bg.c879eb3e.png";